export default __webpack_public_path__ + "static/media/copyIcon.734dfdc0.svg";